import React from 'react';
import {toDecimalFr} from './toDecimalFr';

export interface FormatQuantiteOptions {
  quantite: number;
  uniteCommande: string;
  uniteFacturation: string;
  coefficientCommande: number;
  formatUnite: (unite: string, count: number) => string;
}

/**
 * Formate une quantité en affichant l'unité de commande et, si nécessaire,
 * l'unité de facturation entre parenthèses.
 */
export function formatQuantiteAvecCoefficient({
  quantite,
  uniteCommande,
  uniteFacturation,
  coefficientCommande,
  formatUnite,
}: FormatQuantiteOptions): React.ReactNode {
  const quantiteCommande = toDecimalFr(quantite, 0, 3);
  const uniteCommandeFormatee = formatUnite(uniteCommande, quantite);

  // Si les unités sont identiques, afficher simplement la quantité avec l'unité
  if (uniteCommande === uniteFacturation) {
    return (
      <>
        {quantiteCommande}&nbsp;{uniteCommandeFormatee}
      </>
    );
  }

  // Calculer la quantité de facturation
  const quantiteFacturation = quantite * coefficientCommande;
  const quantiteFacturationFormatee = toDecimalFr(quantiteFacturation, 0, 3);
  const uniteFacturationFormatee = formatUnite(
    uniteFacturation,
    quantiteFacturation,
  );

  // Afficher les deux quantités
  return (
    <>
      {quantiteCommande}&nbsp;
      {uniteCommandeFormatee} ({quantiteFacturationFormatee}
      &nbsp;{uniteFacturationFormatee})
    </>
  );
}
